import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button, Toolbar, TextField, MenuItem } from '@material-ui/core';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import moment from 'moment';
import { dropRight, compact } from 'lodash';
import isMobile from 'ismobilejs';

import { dateTimeFormat, monthes } from '../common/constants';
import { currentDateForStatement } from '../common/OrderUtil';

const currentDate = currentDateForStatement();

console.log('currentDate:',currentDate)
const years = new Array(currentDate.year() - 2019 + 2)
  .join(0)
  .split('')
  .map((value, index) => 2019 + index).reverse();

const toolbarStyles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: isMobile.phone ? 'calc(90%)' : '200px',
    borderBottom: 0,
  },
  spacer: {
    width: 1000,
    flex: '1 1 100%',
    textAlignLast: 'left',
  },
  button: {
    margin: theme.spacing.unit,
    color: theme.palette.background.default,
    backgroundColor: '#4e91fd',
  },
  toolbar: {
    backgroundColor: theme.palette.background.default,
    padding: 5,
  },
});

class StatementTableToolbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      year: this.props.filters.year,
      month: this.props.filters.month,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  handleSubmit = () => {};

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value });
    let year = this.state.year;
    let month = this.state.month;
    if (event.target.name === 'year') {
      year = event.target.value;

      /**
       *    Switch to current year check the month is out of the allowed range or not,
       *        if out of curent range, then set the month to the latest one
       */
      if (year === currentDate.year() && this.state.month > currentDate.month()) {
        month = currentDate.month();
      }
    }
    if (event.target.name === 'month') {
      month = event.target.value;
    }
    this.props.handleFilter({
      year,
      month,
    });
    this.setState({ year, month });
  };

  render() {
    const { classes, doExport, result } = this.props;
    const { year, month } = this.state;

    let monthList = monthes;
    if (year === moment().year()) {
      monthList = monthes.slice(0, currentDate.month() + 1);
    }
    return (
      <Toolbar className={classes.toolbar}>
        <div className={classes.spacer}>
          <TextField
            select
            label="Year"
            className={classes.textField}
            name="year"
            value={year}
            onChange={e => this.handleChange(e)}
          >
            {years.map(value => (
              <MenuItem key={value} value={value}>
                {value}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Month"
            className={classes.textField}
            name="month"
            value={month}
            onChange={e => this.handleChange(e)}
          >
            {monthList.map((value, index) => (
              <MenuItem key={index} value={index}>
                {value}
              </MenuItem>
            ))}
          </TextField>

          <span className="float-right">
            <Button
              id="exportButton"
              variant="contained"
              size="small"
              className={classes.button}
              onClick={() => doExport()}
            >
              Export Statement
            </Button>
          </span>
        </div>
      </Toolbar>
    );
  }
}

StatementTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  handleFilter: PropTypes.func.isRequired,
  doFilter: PropTypes.func.isRequired,
  doExport: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
  result: PropTypes.object,
};

export default withStyles(toolbarStyles)(StatementTableToolbar);



// WEBPACK FOOTER //
// ./src/components/statements/StatementTableToolbar.js